<template>
    <div
        class="blog text"
        v-html="layout.content"
    >
    </div>
</template>
<script>
export default {
    props: {
        layout: {
            type: Object,
            default() {}
        }
    }
}
</script>

<style lang="sass" scoped>
@import "@/styles/vars.sass"
.blog
    max-width: 910px
    margin-left: auto
    margin-right: auto
    margin-top: 8.25%
    margin-bottom: 14%
    @include media-breakpoint-down($hd)
        margin-left: 72 / 750 * 100%
        margin-right: 72 / 750 * 100%

    @media print
        margin-top: 1.2cm
        margin-bottom: 1.2cm
    /deep/ h2
        margin-bottom: 10%
        margin-left: -16%
        padding-right: 16%
        margin-top: 16%
        @include media-breakpoint-down($hd)
            margin-left: 0
        @media print
            margin-left: 0%
            padding-right: 0%
            margin-bottom: .6cm
            margin-top: .6cm
        .story-view &
            margin-left: 0
            padding-right: 8%
    /deep/ h3
            // font-size: 50px
            // line-height: 1.2
            // letter-spacing: -0.03125em
            // font-weight: 500
            margin-bottom: 10%
            margin-left: -16%
            padding-right: 16%
            margin-top: 16%
            @include media-breakpoint-down($hd)
                margin-left: 0
            @media print
                margin-left: 0%
                padding-right: 0%
                margin-bottom: .6cm
                margin-top: .6cm
            .story-view &
                margin-left: 0
                padding-right: 8%

</style>
